const initialState = {
	isLoading: false,
	list: [],
};

function creatorReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_CREATOR':
			return {
				...state,
				isLoading: action.payload
			};
		case 'LIST_CREATOR':
			return {
				...state,
				list: action.payload.creators,
			};
		default:
			return state;
	}
}

export default creatorReducer;
